<template>
  <v-container fluid>
    <!-- HEADER - PAGE TITLE & ACTION BTN -->
    <v-col class="pa-0 col-12" v-if="hasBackButton">
      <v-btn icon class="main-back-arrow mb-2 mt-1 mr-1" @click="goToRoute">
        <v-icon :title="$t('goBackButtonLabel')">arrow_back</v-icon>
      </v-btn>
    </v-col>
    <v-col class="pa-0 col-12">
      <!-- banner ad espansione-->
      <base-page-description-panel
        :title-path="getPageDescDetails.title"
        :title-params="getPageDescDetails.params"
        :text="getPageDescDetails.text"
        :needHtml="getPageDescDetails.needHtml"
      ></base-page-description-panel>
    </v-col>
    <div class="container-panel mt-3">
      <v-card flat color="cardbg">
        <v-card-text>
          <!-- LOAD A SECTION BASED ON TYPE -->
          <component
            :is="activeComponent"
            :items="items"
            :contentType="getContentType"
          >
            <base-filter-container
              slot="filters"
              :pageType="type"
              :storeType="storeType"
              :translateMultiSelectItem="translateMultiSelectItem"
              @retrieveitems="retrieveItems"
            />
          </component>
        </v-card-text>
        <!-- PAGINATION -->
        <base-pagination
          :pageType="type"
          :storeType="storeType"
          @retrieveitems="retrieveItems"
        />
      </v-card>
    </div>
  </v-container>
</template>

<script>
// FILTERS
import BaseFilterContainer from "./../../components/BaseFilterContainer.vue";

// PAGES
import AppointmentsList from "../../components/AppointmentsList";
import NewsTutorialList from "../../components/NewsTutorialList";
import AcceptedAppointmentsSection from "./../../components/Bills/AcceptedAppointmentsSection";
import BillAppointmentsList from "./../../components/Bills/BillAppointmentsList";
import BillNewAppointmentList from "./../../components/Bills/BillNewAppointmentList";
import BillsList from "./../../components/Bills/BillsList";
import BillUpdateAppointmentList from "./../../components/Bills/BillUpdateAppointmentList";
import DoneAppointmentsSection from "./../../components/Bills/DoneAppointmentsSection";
import HFDoctorsList from "./../../components/HealthFacilities/HFDoctorsList";
import HFMachineryPerformanceList from "./../../components/HealthFacilities/HFMachineryPerformanceList";
import OperatorsList from "./../../components/OperatorsList";

export default {
  components: {
    BaseFilterContainer,
    NewsTutorialList,
    AppointmentsList,
    OperatorsList,
    BillsList,
    BillAppointmentsList,
    BillNewAppointmentList,
    BillUpdateAppointmentList,
    DoneAppointmentsSection,
    AcceptedAppointmentsSection,
    DoctorsList: HFDoctorsList,
    MachineryPerformanceList: HFMachineryPerformanceList
  },
  props: {
    type: {
      type: String,
      required: true
    },
    storeType: {
      type: String,
      required: false
    },
    routeNameToGo: {
      type: String,
      required: false
    },
    // NOTE: PROP ONLY FOR APPOINTMENT RELATED VIEWS AND BILL RELATED VIEWS
    contentOptions: {
      dataType: {
        type: String,
        default: () => {},
        required: true
      }
    }
  },
  data() {
    return {
      officeId: null
    };
  },
  watch: {
    type: "iniatialize",
    $route: {
      handler: function () {
        if (this.type == "appointments") {
          this.$store.dispatch("appointments/getItems", this.officeId);
        }
      },
      deep: true
    }
  },
  created() {
    this.iniatialize();
  },
  computed: {
    activeComponent() {
      if (this.type == "newsTutorial") return "news-tutorial-list";
      else if (this.type == "operators") return "operators-list";
      else if (this.type == "bills") return "bills-list";
      else if (this.type == "appointments") return "appointments-list";
      else if (this.type == "billAppointments") {
        if (this.$store.getters["billAppointments/toFilter"] === "DONE")
          return "done-appointments-section";
        else if (
          this.$store.getters["billAppointments/toFilter"] === "ACCEPTED"
        )
          return "accepted-appointments-section";
      } else if (this.type == "hfManagement.officeStaff") return "doctors-list";
      else if (this.type == "hfManagement.machineryPerformance")
        return "machinery-performance-list";
      else throw new Error("Trying to load a page which does not exist");
      return "";
    },
    getPageDescDetails() {
      let config = {};
      switch (this.type) {
        case "appointments":
          config.title =
            this.contentOptions.dataType === "request"
              ? "appointments.request.title"
              : "appointments.booking.title";
          config.text =
            this.contentOptions.dataType === "request"
              ? "appointments.request.desc"
              : "appointments.booking.desc";
          config.needHtml = true;
          break;
        case "billAppointments":
          let titleToUse =
            this.$store.getters["billAppointments/pageDescTitle"];
          config.title = `billAppointments.title.${titleToUse}`;
          let textToUse = this.$store.getters["billAppointments/pageDescText"];
          config.text = `billAppointments.description.${textToUse}`;
          break;
        case "operators":
          config.title = `${this.type}.title`;
          config.text = `${this.type}.text`;
          config.needHtml = true;
          break;
        default:
          config.title = `${this.type}.title`;
          config.text = `${this.type}.text`;
          config.needHtml = false;
          break;
      }
      config.params = this.pageDescParams;
      return config;
    },
    pageDescParams() {
      if (this.type === "billAppointments")
        return this.$store.getters["billAppointments/pageDescParams"];
      else return {};
    },
    items() {
      return this.$store.getters[`${this.storeType}/items`];
    },
    getContentType() {
      return this.contentOptions?.dataType || null;
    },
    translateMultiSelectItem() {
      switch (this.type) {
        case "hfManagement.officeStaff":
        case "hfManagement.machineryPerformance":
          return false;
        default:
          return true;
      }
    },
    hasBackButton() {
      switch (this.type) {
        case "hfManagement.officeStaff":
        case "hfManagement.machineryPerformance":
        case "billAppointments":
          return true;
        default:
          return false;
      }
    }
  },
  methods: {
    iniatialize() {
      this.officeId = this.$store.getters["hfManagement/officeId"];
      let setIsBillSuspended =
        this.getContentType === "sentback" ? true : false;
      this.$store.commit("bills/SET_IS_BILL_SUSPENDED", setIsBillSuspended);
      if (this.type === "appointments") {
        this.$store.commit(
          "appointments/setType",
          this.contentOptions.dataType
        );
      }
      // RETRIEVE ITEMS FOR ACTIVE ROUTE
      this.retrieveItems();
    },
    reset() {},
    retrieveItems() {
      if (this.type === "appointments") {
        this.$store
          .dispatch("appointments/getItems", this.officeId)
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            this.$store.commit("loading/CLOSE_LOADING_DIALOG", {
              root: true
            });
          });
      } else {
        this.$store
          .dispatch(`${this.storeType}/getItems`, this.officeId)
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            this.$store.commit("loading/CLOSE_LOADING_DIALOG", {
              root: true
            });
          });
      }
    },
    goToRoute() {
      this.$router.push({ name: this.routeNameToGo });
    }
  },
  beforeRouteEnter(to, from, next) {
    sessionStorage.setItem("BILL_DETAILS_INCOMING_ROUTE", from.name);
    next();
  }
};
</script>

<style scoped>
.container-panel {
  background-color: var(--card-bg);
}
</style>
